import {debug} from '../../logging/debug';
/**
 * Created with IntelliJ IDEA.
 * User: aprzybyszewski
 * Date: 07.06.13
 * Time: 13:06
 * To change this template use File | Settings | File Templates.
 */

import TimerEvent = createjs.TimerEvent;
import { Timer } from "@goodgamestudios/createjs-utilities";

import { Signal } from "signals.js";

export class LicenseRefresher {
    public static NAME: string = "LicenseRefresher";

    private _initialShowDelayTimeSeconds: number;
    private _licenseShowScheduleSeconds: number;
    private _licencseDisplayDurationSeconds: number;

    private licenseShowSchedule: Timer;
    private licenseDisplayDuration: Timer;

    public licenseAgeRatingShowed: Signal;
    public licenseShowed: Signal;
    public licenseHided: Signal;

    private _intervalReachCount: number;

    constructor(initialShowDelaySeconds: number, licenseShowScheduleMinutes: number, licenseDisplayDurationSeconds: number) {
        this._initialShowDelayTimeSeconds = initialShowDelaySeconds;
        this._licenseShowScheduleSeconds = licenseShowScheduleMinutes * 60;
        this._licencseDisplayDurationSeconds = licenseDisplayDurationSeconds;

        this.initializeTimers();

        this._intervalReachCount = 0;

        this.licenseAgeRatingShowed = new Signal();
        this.licenseShowed = new Signal();
        this.licenseHided = new Signal();
    }

    private initializeTimers(): void {
        // Show interval. Runs inifitely
        this.licenseShowSchedule = new Timer(this.secondsToMilliseconds(this._initialShowDelayTimeSeconds), 0);

        // Delay after the license should be hided
        this.licenseDisplayDuration = new Timer(this.secondsToMilliseconds(this._licencseDisplayDurationSeconds), 1);
    }

    private secondsToMilliseconds(seconds: number): number {
        return seconds * 1000;
    }

    public startRefreshing(): void {
        // Start infinite schedule
        this.startLicenseShowSchedule();
    }

    public stopRefreshing(): void {
        // Stop all timers
        this.licenseDisplayDuration.stop();
        this.licenseShowSchedule.stop();

        // Remove listeners
        this.licenseShowSchedule.removeEventListener(TimerEvent.TIMER, this.bindFunction(this.onLicenseShowScheduleIntervalReached));
        this.licenseDisplayDuration.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onLicenseDisplayDurationComplete));
    }

    public dispose(): void {
        this.stopRefreshing();

        // Reset counter
        this._intervalReachCount = 0;

        // Remove signal listeners
        this.licenseAgeRatingShowed.removeAll();
        this.licenseShowed.removeAll();
        this.licenseHided.removeAll();

        this.licenseDisplayDuration = null;
        this.licenseShowSchedule = null;

        this.licenseAgeRatingShowed = null;
        this.licenseShowed = null;
        this.licenseHided = null;
    }

    private startLicenseShowSchedule(): void {
        if (!this.licenseShowSchedule.hasEventListener(TimerEvent.TIMER)) {
            this.licenseShowSchedule.addEventListener(TimerEvent.TIMER, this.bindFunction(this.onLicenseShowScheduleIntervalReached));
        }
        this.licenseShowSchedule.start();
    }

    public onLicenseShowScheduleIntervalReached(event: TimerEvent = null): void {
        debug("Interval reached after: " + this.licenseShowSchedule.delay / 1000 + " seconds / " + this.licenseShowSchedule.delay / 60000 + " minutes");

        if (!event) {
            // Display initial age rating info
            this.licenseAgeRatingShowed.dispatch();
        }

        // 1. time reached
        if (this._intervalReachCount == 0) {
            // The initial delay have to be subtracted from the schedule time due has passed already
            this.licenseShowSchedule.delay = this.secondsToMilliseconds(this._licenseShowScheduleSeconds - this._initialShowDelayTimeSeconds);

            // Display initial age rating info
            this.licenseAgeRatingShowed.dispatch();
        }
        // 2. time reached
        else if (this._intervalReachCount == 1) {
            // From now on: Use the default schedule time
            this.licenseShowSchedule.delay = this.secondsToMilliseconds(this._licenseShowScheduleSeconds);
        }

        // Show license
        this.licenseShowed.dispatch();

        // Start hide timer
        this.startLicenceHideTimer();

        // Increment reach count
        this._intervalReachCount++;
    }

    private startLicenceHideTimer(): void {
        this.licenseDisplayDuration.addEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onLicenseDisplayDurationComplete));
        this.licenseDisplayDuration.start();
    }

    private onLicenseDisplayDurationComplete(event: TimerEvent): void {
        debug("Hide license after: " + this.licenseDisplayDuration.delay / 1000 + " seconds / " + this.licenseDisplayDuration.delay / 60000 + " minutes");
        this.licenseDisplayDuration.removeEventListener(TimerEvent.TIMER_COMPLETE, this.bindFunction(this.onLicenseDisplayDurationComplete));
        // hide license
        this.licenseHided.dispatch();
    }
}
